import { useMemo } from 'react';

type Clipboard = {
  copy: (value: string) => void;
  enabled: boolean;
};

const useClipboard = (): Clipboard => {
  const enabled = useMemo(() => !!navigator.clipboard, []);
  const copy = (value: string) => {
    navigator.clipboard.writeText(value);
  };

  return { copy, enabled };
};

export default useClipboard;
